import { query, mutate } from '../../apollo/client';

export async function getPartners() {
  const { default: getPartnersQuery } = await import('../../graphql/partners/getPartners');

  const response = await query(getPartnersQuery);
  return response.data.getPartners;
}

export async function getStages() {
  const { default: getStagesQuery } = await import('../../graphql/partners/getStages');

  const response = await query(getStagesQuery, null, false);
  return response.data.getStages;
}

export async function visitCommunityPage() {
  const { default: visitCommunityPageMutation } = await import('../../graphql/partners/visitCommunityPage');

  await mutate(visitCommunityPageMutation, null, false);
}
